import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import aboutImage from '../../../assets/images/about/aboutCompanyDetails/aboutImage.png'

const AboutCompanyDetails = () => {
    return (
        <div className='aboutCompanyDetails'>
            <div className='aboutCompanyDetailsContainer'>
                <div className='aboutCompanyDetailsContent'>
                    <div className='aboutCompanyDetailsTitle'>
                        V2 CONSTRUCTIONSS
                    </div>
                    <div>
                        <p>With decades of experience in civil construction, we specialize in delivering end-to-end solutions, from structural execution to intricate interior works. Our reputation is built on timely project completion, superior craftsmanship, and customer satisfaction. At V2 Constructionss, we don’t just build structures—we create landmarks that stand the test of time.</p>
                    </div>
                    <div>
                        <p>At V2 Constructionss, we take pride in shaping the skyline with precision, excellence, and innovation. Established in 1999, our journey has been marked by the successful completion of over 150 projects, spanning industrial, commercial, and residential sectors. From factories and hatcheries to high-end residential developments and joint ventures, we bring expertise, efficiency, and an unwavering commitment to quality in every project we undertake.</p>
                    </div>
                    <div>
                        <p style={{ fontWeight: 500 }} >In Collaboration with Dinesh Builders.</p>
                    </div>
                </div>
                <div className='aboutCompanyDetailsImage'>
                    <LazyLoadImage
                        draggable={false}
                        src={aboutImage}
                        alt="aboutCompanyImage"
                        effect="blur"
                        width="100%"
                        height="100%"
                        style={{ objectFit: 'cover' }}
                    />
                </div>
            </div>
        </div>
    )
}

export default AboutCompanyDetails